/**
 * @Author: v_jppjpeng
 * @Date: 2024-12-20 15:34:05
 * @Explain: list-item
 */
import classNames from 'classnames';
import { ReactNode } from 'react';
import { TooltipProps } from 'tdesign-react';
import Tooltip from '../toolTip';

type ListItemProps = {
  key: string;
  title?: string;
  tooltip?: string;
  disabled?: boolean;
  selected?: boolean;
  textRender: ReactNode;
  tooltipProps?: TooltipProps;
  /** 自定义渲染 */
  customOption?: () => ReactNode;
  onClose?: () => void;
  onClick?: () => void;
};

const ListItem = (props: ListItemProps) => {
  const {
    key,
    title,
    tooltip,
    disabled,
    selected,
    textRender,
    tooltipProps,
    customOption,
    onClose,
    onClick,
  } = props;

  const onRender: any = () => {
    if (customOption) {
      return customOption?.();
    } else if (tooltip) {
      return (
        <Tooltip showArrow={false} content={tooltip} {...tooltipProps}>
          {textRender}
        </Tooltip>
      );
    } else {
      return textRender;
    }
  };

  return (
    <li
      key={key}
      title={title}
      className={classNames('t-list-item', {
        'is-selected': selected,
        'is-disabled': disabled,
      })}
      onClick={() => {
        if (!disabled) {
          onClose?.();
          onClick?.();
        }
      }}
    >
      <div className="t-list-item-main">{onRender()}</div>
    </li>
  );
};

export default ListItem;
